export class MailDestinataireBaseContactInput {
  public contactId: number;
  public historiqueDescription?: string; // It is used as mail history description, set contact fullname as default value
}
